// @flow
import {
    INTEGRATIONS_CLOUDFLARE,
    INTEGRATIONS_CLOUDFLARE_SUCCESS,
    INTEGRATIONS_CLOUDFLARE_FAILED,
    INTEGRATIONS_CLOUDFLARE_SAVE
} from '../../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    cloudflare: null
};

type IntegrationsAction = { type: string, payload: {} | string };
type State = { loading?: boolean, +value?: boolean, cloudflare?: {} | null, saving?: boolean};

const IntegrationsCloudFlare = (state:State = INIT_STATE, action: IntegrationsAction) => {
    switch (action.type) {
        case INTEGRATIONS_CLOUDFLARE:
            return { ...state, loading: true };
        case INTEGRATIONS_CLOUDFLARE_SAVE:
            return { ...state, saving: true };
        case INTEGRATIONS_CLOUDFLARE_SUCCESS:
            return { ...state, cloudflare: action.payload, loading: false, saving: false, error: null };
        case INTEGRATIONS_CLOUDFLARE_FAILED:
            return { ...state, error: action.payload, loading: false, saveing: false };
        default: return { ...state };
    }
}

export default IntegrationsCloudFlare;